export const getUser = `query GetUser {getUser { partnerPortalData {paymentPortalUrl firstName isComplimentarySubscription}}}`;